import { Avatar, AvatarFallback, AvatarImage } from '@components/ui/avatar';
import { imgAssets } from '@utils/img-assets';
import { FC } from 'react';
import { cn } from '@utils/cn';

const LOGO_URL = imgAssets.brand.logo;

type LqdLogoProps = {
  title?: string;
  imgUrl?: string;
  size?: 'sm' | 'md' | 'lg';
  square?: boolean;
  renderTitle?: boolean;
};

const LqdLogo: FC<LqdLogoProps> = ({
  title = 'Lqd',
  imgUrl = LOGO_URL,
  size = 'sm',
  square = false,
  renderTitle = true
}) => {
  return (
    <div className="flex items-center gap-4">
      <Avatar
        className={cn(
          square && 'rounded-sm',
          size === 'sm' && 'size-8',
          size === 'md' && 'size-10',
          size === 'lg' && 'size-12'
        )}
      >
        <AvatarImage src={imgUrl} alt="Lqd logo" />
        <AvatarFallback>Lqd</AvatarFallback>
      </Avatar>

      {renderTitle && (
        <span className="self-center text-section-title whitespace-nowrap text-foreground">
          {title}
        </span>
      )}
    </div>
  );
};

export default LqdLogo;
